import React, { useState, useEffect } from "react";
import Hero from "./Hero";
import axios from "axios";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InfringementReportPDF from "../customcms/src/components/admin/InfringementReportPDF";
import { Footer } from "./Footer";
import dotSignalPdf from "../assets/infringements/Infringement_Report_Dotsignal.pdf";
import twillioSignalPdf from "../assets/infringements/Infringement_Report_twilio.pdf";
import accessingPdf from "../assets/infringements/Infringement_Report_accessing technologies (3).pdf";
import logo from "../assets/clientImages/Screenshot from 2025-11-04 15-06-34.png";

export const SampleInfringementReport = () => {
  const [infringementDetails, setinfringementDetails] = useState([]);
  const [loading, setIsLoading] = useState(false);

  const getViolationAnalysis = async () => {
    try {
      setIsLoading(true);
      const response = await axios(
        `${process.env.REACT_APP_API_PATH}/getViolationAnalysis`
      );
      if (response.status === 200) {
        setinfringementDetails(
          response.data.filter((item) => {
            return item.isRequested === false;
          })
        );
        setIsLoading(false);
      }
    } catch (err) {
      console.log(err.message, "Err");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getViolationAnalysis();
  }, []);

  return (
    <>
      <Hero bgImage={""} imageText={{ title: "Sample Infringement Report" }} />
      <div className="bg-white flex justify-center items-center pt-5 pb-5">
        <div className="w-11/12 lg:w-4/5 mt-5 mb-3 py-5 px-6 bg-white">
          <div className="flex bg-white justify-center items-center"></div>
          <div className=" items-center overflow-x-auto">
            <div className="p-10 flex item-center justify-between">
              <div class="max-w-md rounded-2xl overflow-hidden shadow-lg bg-white">
                <div class="h-52 w-full relative">
                  <div className="h-52 w-full relative">
                    <img
                      src={logo}
                      alt="Blog Cover"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-40 p-4">
                        <h2 className="text-white text-xl font-semibold">
                            Sample infringement report 1
                        </h2>
                    </div>
                  </div>
                </div>
                <div class="p-4">
                  <div className="text-center">
                    <button
                      id="readMoreBtn"
                      className="mt-4 px-4  text-blue-500/90 underline  font-medium text-lg rounded transition duration-200"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = dotSignalPdf;
                        link.download = "Infringement_Report_1.pdf";
                        link.click();
                      }}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>

              <div class="max-w-md  rounded-2xl overflow-hidden shadow-lg bg-white">
                <div class="h-52 w-full relative">
                  <div className="h-52 w-full relative">
                    <img
                      src={logo}
                      alt="Blog Cover"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-4">
                      <h2 className="text-white text-xl font-semibold">
                        Sample infringement report 2
                      </h2>
                    </div>
                  </div>
                </div>
                <div class="p-4">
                  <div className="text-center">
                    <button
                      id="readMoreBtn"
                      className="mt-4 px-4  underline   font-medium text-lg rounded text-blue-500/90 underline  transition duration-200"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = twillioSignalPdf;
                        link.download = "Infringement_Report_2.pdf";
                        link.click();
                      }}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>

              <div class="max-w-md  rounded-2xl overflow-hidden shadow-lg bg-white">
                <div class="h-52 w-full relative">
                  <div className="h-52 w-full relative">
                    <img
                      src={logo}
                      alt="Blog Cover"
                      className="h-full w-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 p-4">
                      <h2 className="text-white text-xl font-semibold">
                        Sample infringement report 3
                      </h2>
                    </div>
                  </div>
                </div>
                <div class="p-4">
                  <div className="text-center">
                    <button
                      id="readMoreBtn"
                      class="mt-4 px-4  underline text-blue-500/90 underline  font-medium text-lg rounded  transition duration-200"
                      onClick={() => {
                        const link = document.createElement("a");
                        link.href = accessingPdf;
                        link.download = "Infringement_Report_3.pdf";
                        link.click();
                      }}
                      // onClick={() => navigate(`/page/${page.slug}`)}
                    >
                      Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
